import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class TipoChequeService {

  // tiposCheques: any = [
  //   { value: 1, label: "Por Depositar" },
  //   { value: 2, label: "Depositado" },
  //   { value: 3, label: "Protestado" },
  //   { value: 4, label: "Ingresado" },
  //   { value: 5, label: "Redepositado" },
  //   { value: 7, label: "Pagado" },
  // ]

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  // GetTiposCheques() {
  //   return this.tiposCheques;
  // }

  GetTiposCheques(callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        {
          tipo_cheque {
            obtenerTodos {
              respuesta {
                registros {
                  codigo
                  nombre
                }
              }
            }
          }
        }
        `,
        variables: {},
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.tipo_cheque.obtenerTodos
        callback({ mensajes, respuesta })
      }
    );
  }

  GetLabelByValue(value: number) {
    this.GetTiposCheques(({ respuesta }) => {
      const { registros } = respuesta; 
      const element = registros.filter(tipo => tipo.codigo === value)
      if (!element || element.length === 0)
        return ''
      return element[0].label
    })
  }

}
